import { MapPin, ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { branchList } from "../data";

export default function BranchSelector({ selectedBranch, setSelectedBranch, isMobile = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentBranch = branchList.find(b => b.id === selectedBranch) || branchList[0];

  const branchColors = {
    mangalam: "border-orange-500 bg-orange-50 text-orange-600",
    koottayi: "border-green-500 bg-green-50 text-green-600",
    vettom: "border-teal-500 bg-teal-50 text-teal-600",
  };

  const handleBranchSelect = (branchId) => {
    setSelectedBranch(branchId);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-all duration-300 ${
          branchColors[selectedBranch] || "border-gray-300 hover:border-[#4a7c59]"
        } ${isMobile ? "w-full justify-between" : ""}`}
      >
        <div className="flex items-center gap-2">
          <MapPin className="w-4 h-4" />
          <span className="text-sm font-medium">{currentBranch.shortName}</span>
        </div>
        <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div className={`${isMobile ? "w-full" : "absolute top-full right-0 mt-2 w-56"} bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50`}>
          <div className="p-2">
            <p className="text-xs text-gray-500 px-3 py-1 font-medium">Select Branch</p>
            {branchList.map((branch) => (
              <button
                key={branch.id}
                onClick={() => handleBranchSelect(branch.id)}
                className={`w-full text-left px-3 py-2.5 rounded-lg transition-all duration-200 flex items-center gap-3 ${
                  selectedBranch === branch.id
                    ? "bg-[#4a7c59]/10 text-[#4a7c59] font-semibold"
                    : "hover:bg-gray-50 text-gray-700"
                }`}
              >
                <div className={`w-2 h-2 rounded-full ${
                  branch.id === "mangalam" ? "bg-orange-500" :
                  branch.id === "koottayi" ? "bg-green-500" :
                  "bg-teal-500"
                }`}></div>
                <span className="text-sm">{branch.name}</span>
                {selectedBranch === branch.id && (
                  <span className="ml-auto text-xs text-[#4a7c59]">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}